
import Vue, { PropType } from 'vue';
import { Modal, Button } from '@descomplica/vue-components';

export interface IDialogButton {
  label: String;
  action: String;
  type: 'outline' | 'success' | 'error';
}

export default Vue.extend({
  components: {
    Modal,
    Button,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: undefined,
    },
    buttons: {
      type: Array as PropType<IDialogButton[]>,
      required: true,
    },
    disposeAction: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      isActive: true, // TODO: refactor according to parent component control
    };
  },
  methods: {
    mountButtonAttrs(button: IDialogButton): any {
      return {
        medium: true,
        border: button.type === 'outline',
        primary: button.type === 'success',
        class: { 'error-btn': button.type === 'error' },
      };
    },
    submitAction(selectedButton: IDialogButton): void {
      this.$emit('select', {
        action: selectedButton.action,
      });
    },
    submitDisposeAction(): void {
      this.$emit('select', {
        action: this.disposeAction,
      });
    },
  },
});
